import peripherathon from "../../pdfs/technical_activities/peripherothon_1.0.pdf";
import technohunt from "../../pdfs/technical_activities/technohunt.pdf";
import innovationCup from "../../pdfs/technical_activities/innovation_cup_23.pdf";
import siliconToSystem from "../../pdfs/technical_activities/silicon_to_system_journey.pdf";
import bugbuster from "../../pdfs/technical_activities/bugbuster_final.pdf";
import SIH2022 from "../../pdfs/technical_activities/SIH2022.pdf";

export default [
  {
    image: "https://i.ibb.co/9yx9Wf6/image2.png",
    title: "Peripherathon 1.0: AI-POWERED IOT HARDWARE HACKATHON",
    text: `Round 1: 20th April 2023
Online Training on IOT Board: 3rd Week of April 2023 
Round 2: 7th May 2023
`,
    report: peripherathon,
  },
  {
    image: "https://i.ibb.co/p4R3z3H/image4.png",
    title: "Technohunt-2022",
    text: `A treasure hunt based electronic circuit designing contest from 13th November, 2022 to 20th November, 2022`,
    report: technohunt,
  },
  {
    image: "https://i.ibb.co/KXDr3c9/image3.png",
    title: "S.P.I.T Innovation Cup 2023: An event for hardware aficionados!",
    text: `Round 1: 29th March 2023
Round 2: 8th April 2023
Round 3: 8th May 2023
`,
    report: innovationCup,
  },
  {
    image: "https://i.ibb.co/tB40fm2/image6.png",
    title: "Silicon to System Journey",
    text: `Conducted by Industry Experts: IngotSEMI Technologies LLP., Bangalore`,
    report: siliconToSystem,
  },
  {
    image: "https://i.ibb.co/rFLnzF4/image5.png",
    title: "BUGBUSTER: 2024",
    text: `A National Level Contest on Electronic Circuit Troubleshooting (Redefining Circuit Troubleshooting, One Bug at a Time), from 6th April 2024 to 13th April 2024`,
    report: bugbuster,
  },
  {
    image: "https://i.ibb.co/Ky7zjGy/image1.png",
    title: "Smart India Hackathon SIH2022",
    text: `Conducted on 25 March 2022`,
    report: SIH2022,
  },
];
